<script setup>
// import tabbar from "@/components/tabbar/index.vue";
import NavBar from "@/components/nav-bar/index.vue";
import { useDark } from '@vueuse/core'

const isDark = useDark();
</script>

<template>
  <div class="app-wrapper">
    <van-config-provider flex flex-col class="page h100%" :theme="isDark ? 'dark' : 'light'">
      <!-- 头部 -->
      <nav-bar />
      <div flex-1 overflow-y-auto overflow-x-hidden>
        <!-- 路由缓存 -->
        <router-view v-slot="{ Component, route }">
          <keep-alive>
            <component :is="Component" :key="route.fullPath" v-if="route.meta.keepAlive" />
          </keep-alive>
          <component :is="Component" :key="route.fullPath" v-if="!route.meta.keepAlive" />
        </router-view>
      </div>
      <!-- 底部 -->
      <!-- <tabbar /> -->
    </van-config-provider>
  </div>
</template>

<style lang="scss" scoped>
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>
